<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item, index) in levelList" :key="item.path">
        <span
          v-if="item.redirect === 'noRedirect' || index == levelList.length - 1 || item.meta.isMenus"
          class="no-redirect"
        >
          {{
            typeof item.meta.title === "string"
              ? item.meta.title || "no-name"
              : item.meta.title[$route.params.type] || $route.params.type
          }}
        </span>
        <!-- <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a> -->
        <a v-else @click.prevent="handleLink(item, index)">{{
          typeof item.meta.title === "string"
            ? item.meta.title || "no-name"
            : item.meta.title[$route.params.type] || $route.params.type
        }}</a>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
import pathToRegexp from 'path-to-regexp'
import { asyncRoutes } from '@/router'
import { queryTostr } from '@/utils/utils'
export default {
  data() {
    return {
      levelList: null
    }
  },
  watch: {
    $route(route) {
      // if you go to the redirect page, do not update the breadcrumbs
      if (route.path.startsWith('/redirect/')) {
        return
      }
      this.getBreadcrumb()
    }
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb() {
      // only show routes with meta.title
      const matched = this.$route.matched.filter(item => item.meta && item.meta.title)
      const first = matched[0]
      if (!this.isDashboard(first)) {
        // matched = [{ path: '/dashboard', meta: { title: '店铺' }}].concat(matched)
      }
      const level = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
      // 处理面包屑
      if (level.length > 1 && level[1].meta.parentPath) {
        const moduleList = asyncRoutes.filter(item => item.path === level[0].path)
        const centerRouter = this.addCenterRouters(level[0].path, level[1].meta.parentPath, moduleList)
        const newCenterRouter = centerRouter.reverse()
        this.levelList = [level[0], ...newCenterRouter, level[1]]
      } else {
        this.levelList = level
      }
    },
    // 循环添加中间层
    addCenterRouters(__path__, __parentPath__, moduleList) {
      const centerRouter = []
      this.recursion(__path__, __parentPath__, centerRouter, moduleList)
      return centerRouter
    },
    // 递归方法
    recursion(__path__, __parentPath__, centerRouter, moduleList) {
      moduleList[0].children.map(item => {
        if (item.path === __parentPath__) {
          centerRouter.push({
            path: __path__ + '/' + item.path,
            meta: { ...item.meta, title: typeof item.meta.title === 'string' ? item.meta.title || 'no-name' : item.meta.title[this.$route.params.type] || this.$route.params.type.slice(2) }
          })
          if (item.meta.parentPath) {
            this.recursion(__path__, item.meta.parentPath, centerRouter, moduleList)
          }
        }
      })
    },
    isDashboard(route) {
      const name = route && route.name
      if (!name) {
        return false
      }
      return name.trim().toLocaleLowerCase() === 'Dashboard'.toLocaleLowerCase()
    },
    pathCompile(path) {
      // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
      const { params } = this.$route
      var toPath = pathToRegexp.compile(path)
      return toPath(params)
    },
    handleLink(item, index) {
      if (item.meta.isMenus) return
      const { redirect } = item
      let { path } = item
      if (redirect) {
        // this.$router.push(redirect)
        // this.$router.push({ path: path + '/' + redirect })
        //
        //
        //
        //
        if (item.meta.hasParams) {
          let num = 0
          this.$route.matched.map((val, index) => {
            if (val.redirect === redirect && path === val.path) {
              num = this.$route.matched.length - index
            }
          })
          this.$router.back(-num)
        } else {
          if (redirect.indexOf('/') === 0) {
            this.$router.push({ path: redirect })
          } else {
            this.$router.push({ path: path + '/' + redirect })
          }
        }
        return
      }
      // 处理面包屑多级路由携带参数
      if (item.meta.hasParams) {
        path = path.slice(0, -5) + item.meta.title + '?' + queryTostr(this.$route.query)
        this.$router.push(path)
      } else {
        this.$router.push(this.pathCompile(path))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 8px;

  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>
